"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * This component is the customer uploaded artwork object on the Konva canvas
 */
var react_1 = __importDefault(require("react"));
var react_konva_1 = require("react-konva");
var use_image_1 = __importDefault(require("use-image"));
var ArtworkImage = function (_a) {
    var _b = _a.artworkProps, _c = _b.x, x = _c === void 0 ? 0 : _c, _d = _b.y, y = _d === void 0 ? 0 : _d, _e = _b.width, width = _e === void 0 ? 0 : _e, _f = _b.height, height = _f === void 0 ? 0 : _f, _g = _b.scaleX, scaleX = _g === void 0 ? 0 : _g, _h = _b.scaleY, scaleY = _h === void 0 ? 0 : _h, _j = _b.rotation, rotation = _j === void 0 ? 0 : _j, onImageLoad = _a.onImageLoad, imageUrl = _a.imageUrl, onLoad = _a.onLoad, onSelect = _a.onSelect, productDims = _a.productDims, _k = _a.visible, visible = _k === void 0 ? true : _k;
    var image = use_image_1.default(imageUrl, "anonymous")[0];
    // When the image loads, pass the size upwards to the Image Editor
    react_1.default.useEffect(function () {
        // console.log("artwork image", image);
        onLoad(true);
        if (onImageLoad && image) {
            // console.log("image loaded", image.width, image.height);
            onImageLoad({ width: image.width, height: image.height });
            // console.log("image loaded");
            onLoad(false);
        }
    }, [image]);
    // console.log("artwork props scale", scaleX, scaleY);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_konva_1.Image, { onClick: onSelect, visible: visible, image: image, offset: { x: width / 2, y: height / 2 }, x: x, y: y, height: height, width: width, scaleY: scaleY, scaleX: scaleX, rotation: rotation, onDragStart: function () {
                console.log("drag start");
                onSelect();
            } })));
};
exports.default = ArtworkImage;
